import type { CSSProperties } from "react";

/**
 * Sole viewport-corner math for the floating launcher shell.
 * Default offset matches `.rv-position-*` CSS (20px). Children of the shell
 * must not re-apply position:fixed corners (avatar/CTA stay relative/absolute).
 */
export function resolveFloatingCornerStyle(
  position: string,
  offset: { x: number; y: number }
): CSSProperties {
  const x = `${offset.x}px`;
  const y = `${offset.y}px`;
  const base: CSSProperties = {
    position: "fixed",
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto",
  };

  switch (position) {
    case "bottom-left":
      return { ...base, bottom: y, left: x };
    case "top-right":
      return { ...base, top: y, right: x };
    case "top-left":
      return { ...base, top: y, left: x };
    case "custom":
      return { ...base, top: y, left: x };
    case "bottom-right":
    default:
      return { ...base, bottom: y, right: x };
  }
}
